import { useContext, useState, useEffect } from "react";
import { CurrencyContext } from "../../contexts/CurrencyContext";

export default function SSLSingle({ activeProduct, products, brand, navigate }) {
  const { selectedCurrency } = useContext(CurrencyContext);
  const [selectedYear, setSelectedYear] = useState(1);
  const product = products.data[0];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sslFeatures = [
    {
      label: "Certificate Reissuance",
      value: product.CanbeReissued ? "&#10005;" : "&#10003;"
    },
    {
      label: "Reissue Days",
      value: product.ReissueDays
    },
    {
      label: "Wildcard Support",
      value: product.isWildcard ? "&#10005;" : "&#10003;"
    },
    {
      label: "SAN Support",
      value: product.IsSanEnable ? "&#10003;" : "&#10005;"
    },
    {
      label: "Validation Type",
      value: product.isEVProduct
        ? "EV"
        : product.isOVProduct
          ? "OV"
          : "DV",
    },
    {
      label: "Server License",
      value: product.isNoOfServerFree ? "&#10005;" : "&#10003;"
    },
    {
      label: "Auto Installation",
      value: product.IsSupportAutoInstall ? "&#10003;" : "&#10005;"
    },
    {
      label: "Mobile Compatibility",
      value: product.isMobileFriendly ? "&#10003;" : "&#10005;"
    },
    {
      label: "Malware Scan",
      value: product.isMalwareScan ? "&#10003;" : "&#10005;"
    },
    {
      label: "Vulnerability Assessment",
      value: product.isVulnerabilityAssessment ? "&#10003;" : "&#10005;"
    },
    {
      label: "Green Address Bar",
      value: product.isGreenBar ? "&#10003;" : "&#10005;"
    },
  ];

  return (
    <div className="ssl-sidebar">
      <div className="sidebar-card">

        <h2 className="sidebar-title">
          {activeProduct.productName}
        </h2>

        <div className="sidebar-section">
          <h4 className="section-label">Description</h4>
          <p className="sidebar-description">{product.ProductDescription}</p>

        </div>
        {/* BASIC INFO */}
        <div className="sidebar-meta-list">
          <div className="meta-item">
            <span className="meta-label">Issuance Time</span>
            <span className="meta-value">
              {product.IssuanceTime}
            </span>
          </div>

          <div className="meta-item">
            <span className="meta-label">Warranty</span>
            <span className="meta-value">
              ${product.Warranty}
            </span>
          </div>

          <div className="meta-item">
            <span className="meta-label">Site Seal</span>
            <span className="meta-value">
              {product.SiteSeal}
            </span>
          </div>
        </div>

        {/* FEATURES */}
        <div className="sidebar-meta-list">
          {sslFeatures.map((item, index) => (
            <div className="meta-item" key={index}>
              <span className="meta-label">{item.label}</span>
              <span className="meta-value" dangerouslySetInnerHTML={{ __html: item.value }} />
            </div>
          ))}
        </div>
        <div className="sidebar-meta-list pricing-section">
          <h4 className="section-label">Pricing</h4>
          <div className="pricing-buttons">
            {[1, 2, 3].map((year) => (
              <button
                key={year}
                className={`pricing-btn ${selectedYear === year ? "active" : ""}`}
                onClick={() => {
                  setSelectedYear(year);
                  localStorage.setItem('ssl_selected_years', year);
                }}
              >
                <span>
                  {selectedCurrency.symbol === "$" && `${selectedCurrency.symbol} `}
                  {activeProduct.prices[`${year}_year`]?.[selectedCurrency.title]}
                  {selectedCurrency.symbol !== "$" && ` ${selectedCurrency.symbol}`}
                </span>
                <span>
                  {year} year{year > 1 ? "s" : ""}
                </span>

              </button>

            ))}
          </div>
        </div>
        <button
          className="btn buy-now-btn"
          onClick={() =>
            navigate(`/user/ssl/csr-generator`)
          }
        >
          Continue
        </button>

      </div>
    </div>
  );
}